"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Evm20Contract = void 0;
const index_1 = require("../index");
const defaultABI = JSON.parse(
// eslint-disable-next-line max-len
'[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]');
class Evm20Contract {
    evmContract;
    abi;
    constructor(evmContract, ABI) {
        this.evmContract = evmContract;
        this.abi = ABI || defaultABI;
    }
    async build(address, evmc, ABI) {
        const evmContract = await index_1.EvmContract.build(evmc, address, ABI);
        return new Evm20Contract(evmContract, ABI);
    }
    getAbi() {
        return this.abi;
    }
    async getName() {
        const name = await this.evmContract.scGet('name', []);
        return name;
    }
    async getSymbol() {
        const symbol = await this.evmContract.scGet('symbol', []);
        return symbol;
    }
    async getDecimals() {
        const decimals = await this.evmContract.scGet('decimals', []);
        return decimals;
    }
    async getBalance(owner) {
        const balanceOf = await this.evmContract.scGet('balanceOf', [index_1.AddressApi.textAddressToEvmAddress(owner)]);
        return balanceOf;
    }
    async getTotalSupply() {
        const totalSupply = await this.evmContract.scGet('totalSupply', []);
        return totalSupply;
    }
    async getAllowance(owner, spender) {
        const allowance = await this.evmContract.scGet('allowance', [
            index_1.AddressApi.textAddressToEvmAddress(owner),
            index_1.AddressApi.textAddressToEvmAddress(spender),
        ]);
        return allowance;
    }
    async transfer(to, amount, key) {
        return this.evmContract.scSet(key, 'transfer', [index_1.AddressApi.textAddressToEvmAddress(to), amount]);
    }
    async transferFrom(from, to, amount, key) {
        return this.evmContract.scSet(key, 'transferFrom', [
            index_1.AddressApi.textAddressToEvmAddress(from),
            index_1.AddressApi.textAddressToEvmAddress(to),
            amount,
        ]);
    }
    async setApprove(spender, value, key) {
        return this.evmContract.scSet(key, 'approve', [index_1.AddressApi.textAddressToEvmAddress(spender), value]);
    }
}
exports.Evm20Contract = Evm20Contract;
